<!-- * TOP HEADER -->
<app-top-header></app-top-header>

<div id="main-content">
  <!-- * LEFT NAVBAR -->
  <app-navbar></app-navbar>

  <!-- * MAIN CONTENT -->
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</div>
